// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_FPz","cls2":"TranslationModal-cls2_csh TranslationModal-cls1_FPz"};